import qs from 'qs';
import { netsparkAxios } from 'core/services/HTTPService';
import {
  // eslint-disable-next-line no-unused-vars
  ICreateOrderItem, IProduct, ISalesTSDItem, IProductParams, ICreateProduct,
  // eslint-disable-next-line no-unused-vars
  IProductCategory, IProductCategoriesParams, ICarriersParams, ICarrier,
} from 'pages/WirelineEngagements/shared/AddOrderModalForm/product.model';
import {
  productsPath, salesSowMataPath, salesSowPath, salesOrdersUrl,
  quoteRequestUrl, contractBundlesUrl,
  getContractBundlesByIdUrl, salesRenewalSowMetaUrl,
  getSalesSowOrderFormUrl, salesOrderActionsUrl, requestBundlesUrl,
  activeNumbersUrl, getEngagementAcceptedUrl, renewalSowUrl,
  getEscalationSupportUrl, getEscalationSupportDataByIdUrl, getRenewalSowItemUrl,
  getRenewalSowEngagementBillingAcceptedUrl, getBookingInfoBookedOrderUrl,
  getOrderCancelUrlById, retentionBookingUrl,
  exportSowDataUrl, getTSDListUrl, getProductCategoriesListUrl,
  getCarriersListUrl, exportActiveNumbersDataUrl,
  getPmEngagementAcceptedUrl, getBillingEngagementAcceptedUrl, salesActiveNumbersMetaUrl,
  getOrderDuplicateUrlById, getOrderDeclineUrlById, exportRenewalSowDataUrl,
} from 'core/api/sales.api/constants';
import { IRequestPaging } from 'core/services/HTTPService.models';
// eslint-disable-next-line no-unused-vars
import { ISowDataListItem, IExportSowDataParams } from '@EngagementsSowData/sowData.model';
import {
  // eslint-disable-next-line no-unused-vars
  IEscalationSupportParams, IPutEscalationSupportParams, IDraftQuote,
  // eslint-disable-next-line no-unused-vars
  IQuote, IContractBundlesById, IOrderCancel,
} from '@EngagementsSowData/salesSow.model';
// eslint-disable-next-line no-unused-vars
import { IActiveNumbersItem, IExportActiveNumbersParams } from '@EngagementsActiveNumbers/activeNumbers.model';
// eslint-disable-next-line no-unused-vars
import { IRenewalSowDataItem, IExportRenewalSowParams } from 'pages/WirelineEngagements/WirelineEngagementsTables/WirelineEngagementsRenewalSowData/renewalSowData.models';
import { IEscalationSupportItem } from '@dashboardEscalationSupport/EscalationSupportTable/model';
import { IRetentionBookingItem } from '@dashboardWirelineRetentionDepartment/RetentionManagerDepartment.models';
import { ITableColumnMetaItem } from 'pages/WirelineEngagements/WirelineEngagementsTables/wirelineEngagementsTables.model';
import { IOrderDataWithRelatedOrders } from 'core/models/order.models';
// eslint-disable-next-line no-unused-vars
import { IBookedOrderParams } from '@dashboardWirelineSellerDepartment/BookingInfo/BookingTableTopToolbar/BookingActionButton/BookedOrder/bookedOrder.model';
// eslint-disable-next-line no-unused-vars
import { IRequestBundlesParams } from 'core/actions/Sales/RequestBundles/RequestBundles.model';
// eslint-disable-next-line no-unused-vars
import { IOrderDecline } from '@EngagementsRenewalSowData/RenewalSowDataTable/RenewalSowDataTableModals/DeclineOrderModal/DeclineOrder.model';

export const getProducts = (params?: IProductParams) => netsparkAxios.get<IProduct[]>(
  productsPath, {
    params,
    paramsSerializer: (paramsData) => qs.stringify(paramsData, { arrayFormat: 'comma' }),
  },
);

export const createProduct = (requestData: ICreateProduct) => (
  netsparkAxios.post<IProduct>(productsPath, requestData)
);

export const createOrder = async (orders: ICreateOrderItem[]) => (
  netsparkAxios.post(salesOrdersUrl, orders)
);

export const getSalesSow = (signal, params) => (
  netsparkAxios.get<IRequestPaging<ISowDataListItem>>(salesSowPath, { signal, params })
);

export const getSalesSowById = (id: string | number) => (
  netsparkAxios.get(`${salesSowPath}${id}/`)
);

export const patchSalesSowById = (id: string | number, params: object) => (
  netsparkAxios.patch(`${salesSowPath}${id}/`, params)
);

export const getSalesSowMeta = () => netsparkAxios.get<ITableColumnMetaItem[]>(salesSowMataPath);

export const getSalesRenewalSowMeta = () => netsparkAxios.get<ITableColumnMetaItem[]>(
  salesRenewalSowMetaUrl,
);

export const getSalesActiveNumbersMeta = () => netsparkAxios.get<ITableColumnMetaItem[]>(
  salesActiveNumbersMetaUrl,
);

export const quoteRequest = (
  draftQuote: IDraftQuote,
) => netsparkAxios.post<IQuote>(quoteRequestUrl, draftQuote);

export const requestBundles = (
  draftQuote: IRequestBundlesParams,
) => netsparkAxios.post<IQuote>(requestBundlesUrl, draftQuote);

export const contractBundles = (params) => netsparkAxios.post(contractBundlesUrl, params);

export const getContractBundles = (
  bundleId: number | string,
) => netsparkAxios.get<IContractBundlesById>(getContractBundlesByIdUrl(bundleId));

export const getSalesSowOrderForm = (id: string | number) => (
  netsparkAxios.get(getSalesSowOrderFormUrl(id))
);

export const putSalesSowOrderForm = (id: string | number, params: object) => (
  netsparkAxios.put(getSalesSowOrderFormUrl(id), params)
);

export const postSalesOrderActions = (params: { orderId: number }[]) => (
  netsparkAxios.post(salesOrderActionsUrl, params)
);

export const getActiveNumbers = (signal: AbortSignal, params: object) => (
  netsparkAxios.get<IRequestPaging<IActiveNumbersItem>>(activeNumbersUrl, { signal, params })
);

export const getSalesActiveNumbersById = (id: string | number) => (
  netsparkAxios.get(`${activeNumbersUrl}${id}/`)
);

export const patchSalesActiveNumbersById = (id: string | number, params: object) => (
  netsparkAxios.patch(`${activeNumbersUrl}${id}/`, params)
);

export const postEngagementAccepted = (orderId: string | number) => (
  netsparkAxios.post(getEngagementAcceptedUrl(orderId))
);

export const postPmEngagementAccepted = (orderId: string | number) => (
  netsparkAxios.post(getPmEngagementAcceptedUrl(orderId))
);

export const postBillingEngagementAccepted = (orderId: string | number) => (
  netsparkAxios.post(getBillingEngagementAcceptedUrl(orderId))
);

export const getRenewalSow = (signal: AbortSignal, params: object) => (
  netsparkAxios.get<IRequestPaging<IRenewalSowDataItem>>(renewalSowUrl, { signal, params })
);

export const getRenewalSowItemById = (id: string | number) => (
  netsparkAxios.get<IOrderDataWithRelatedOrders>(getRenewalSowItemUrl(id))
);

export const postRenewalSowBillingEngagementAccepted = (id: string | number) => (
  netsparkAxios.post(getRenewalSowEngagementBillingAcceptedUrl(id))
);

export const postBookingInfoBookedOrder = (params: IBookedOrderParams) => (
  netsparkAxios.post(getBookingInfoBookedOrderUrl(), params)
);

export const patchRenewalSowItemById = (
  id: string | number,
  renewalSowItem: object,
) => (
  netsparkAxios.patch<IOrderDataWithRelatedOrders>(getRenewalSowItemUrl(id), renewalSowItem)
);

export const postEscalationSupport = (id: string | number, params: IEscalationSupportParams) => (
  netsparkAxios.post(getEscalationSupportUrl(id), params)
);

export const putEscalationSupport = (id: string | number, params: IPutEscalationSupportParams) => (
  netsparkAxios.put(getEscalationSupportDataByIdUrl(id), params)
);

export const getEscalationSupportItem = (id: string | number) => (
  netsparkAxios.get<IEscalationSupportItem>(getEscalationSupportDataByIdUrl(id))
);

export const postOrderCancelById = (id: string | number, params: IOrderCancel) => (
  netsparkAxios.post(getOrderCancelUrlById(id), params)
);

export const postOrderDeclineById = (id: string | number, params: IOrderDecline) => (
  netsparkAxios.post(getOrderDeclineUrlById(id), params)
);

export const postOrderDuplicateById = (id: string | number) => (
  netsparkAxios.post(getOrderDuplicateUrlById(id))
);

export const getRetentionBookingList = (
  signal: AbortSignal,
  params: {
    page: number;
    page_size: number;
    ordering?: string | undefined;
  }) => (
  netsparkAxios.get<IRequestPaging<IRetentionBookingItem>>(retentionBookingUrl, { signal, params })
);

export const exportRenewalSowData = (
  exportParams: IExportRenewalSowParams,
) => netsparkAxios.get(exportRenewalSowDataUrl, {
  params: exportParams,
  responseType: 'blob',
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

export const exportSowData = (
  exportParams: IExportSowDataParams,
) => netsparkAxios.get(exportSowDataUrl, {
  params: exportParams,
  responseType: 'blob',
  paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
});

export const exportActiveNumbersData = (params: IExportActiveNumbersParams) => netsparkAxios
  .get(exportActiveNumbersDataUrl, {
    params,
    responseType: 'blob',
  });

export const getSalesTSDList = () => netsparkAxios.get<ISalesTSDItem[]>(getTSDListUrl);

export const getProductCategoriesList = (
  params?: IProductCategoriesParams,
) => netsparkAxios.get<IProductCategory[]>(getProductCategoriesListUrl, { params });

export const getCarriersList = (
  params: ICarriersParams,
) => netsparkAxios.get<ICarrier[]>(getCarriersListUrl, { params });
